module.exports = __webpack_public_path__ + "img/11.41245a91.png";